import Sortable from 'sortablejs';

$(document).ready(function(){
    if ($('.bn_cycles__item-dropdown-table').length) {
        $('.bn_cycles__item-dropdown-table tbody').sortable({
            forcePlaceholderSize: true,
            update: function(){
                let table = $(this),
                    sortedIDs = table.sortable( 'toArray' );
                $.post('/account/cycles/sort', {'ids' : sortedIDs}, function(data){
                    if (data.status === 1) {
                        let items = table.find('tr');

                        items.each(function(index, item) {
                            $(item).find('.bn_cycles__item-dropdown-counter').text(++index)
                        });

                        flashNotify(data.message);
                    }
                }, 'json')
            }
        }).disableSelection();
    }

    if ($('.bn_cycles__item-dropdown-books').length) {
        $('.bn_cycles__item-dropdown-books').sortable({
            forcePlaceholderSize: true,
            update: function(){
                let wrapper = $(this),
                    sortedIDs = wrapper.sortable( 'toArray' );
                $.post('/account/cycles/sort', {'ids' : sortedIDs}, function(data){
                    if (data.status === 1) {
                        let items = wrapper.find('.bn_cycles-view__table-row');

                        items.each(function(index, item) {
                            $(item).find('.bn_cycles-view__table-number').text(++index)
                        });

                        flashNotify(data.message);
                    }
                }, 'json')
            }
        }).disableSelection();
    }

    if ($('.bn_cycles__item-dropdown-books-mob').length) {
        function getBooksIds()
        {
            let ids = [];
            $('.bn_cycles-view__table-row').each(function(){
                ids.push($(this).attr('id'));
            });
            return ids;
        }

        Sortable.create($('.bn_cycles__item-dropdown-books-mob').get(0), {
            handle: '.bn_cycles-view__table-icon',
            animation: 150,
            onSort: function (evt) {
                $.post('/account/cycles/sort', {'ids' : getBooksIds()}, function(data){
                    if (data.status === 1) {
                        let items = $('.bn_cycles__item-dropdown-books-mob').find('.bn_cycles-view__table-row');

                        items.each(function(index, item) {
                            $(item).find('.bn_cycles-view__table-number').text(++index)
                        });

                        flashNotify(data.message);
                    }
                }, 'json')
            },
        });
    }

    let $mobSelector = $('.bn_cycles__body-drag-mob');

    if ($mobSelector.length) {
        function getIds()
        {
            let ids = [];
            $('.bn_cycles__item').each(function(){
                ids.push($(this).attr('id'));
            });
            return ids;
        }

        Sortable.create($mobSelector.get(0), {
            handle: '.bn_cycles__item-sort',
            animation: 150,
            onSort: function (evt) {
                $.post('/account/cycles/sort-cycles', {'ids' : getIds()}, function(data){
                    if (data.status === 1) {
                        flashNotify(data.message);
                    }
                }, 'json')

            },
        });
    }

    if ($('.bn_cycles__body-drag').length) {
        $('.bn_cycles__body-drag').sortable({
            forcePlaceholderSize: true,
            update: function(){
                let table = $(this),
                    sortedIDs = table.sortable( 'toArray' );
                $.post('/account/cycles/sort-cycles', {'ids' : sortedIDs}, function(data){
                    if (data.status === 1) {
                        flashNotify(data.message);
                    }
                }, 'json')
            }
        }).disableSelection();
    }
});

$(document).on('click', '.bn_cycles__item.dropdown', function(e) {
    if ($(e.target).closest('.bn_cycles__item-dropdown, .bn_menu-dropdown__button, .bn_menu-dropdown__overlay, .bn_menu-dropdown__items-wrapper').length) return;

    let that = $(this),
        dropdown = that.find('.bn_cycles__item-dropdown');

    that.stop().toggleClass('open');

    dropdown.stop().slideToggle();
})